import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import CommoditiesSection from "@/components/landing/CommoditiesSection";
import ValueProposition from "@/components/landing/ValueProposition";
import Categories from "@/components/landing/Categories";
import BigCTA from "@/components/landing/BigCTA";
import ProcessFlow from "@/components/landing/ProcessFlow";
import FAQSection from "@/components/landing/FAQSection";
import Footer from "@/components/landing/Footer";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function LandingPage() {
  useScrollReveal();

  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-white text-slate-900 overflow-x-hidden"
    >
      <Header />
      <Hero />
      <CommoditiesSection />
      <ValueProposition />
      <Categories />
      <BigCTA />
      <ProcessFlow />
      <FAQSection />
      <Footer />
    </main>
  );
}
